// Copied from coulomb-commons-ui soh-band-migration 0.1.0 (src/components/ChartTooltip.jsx).
// Hover card for BucketSankeyChart. Renders a model from sankeyTooltipModel.js.

import React from "react";
import { COLOR, FONT_SANS } from "./sankeyTokens";

const TONE_COLOR = { up: COLOR.emerald, down: COLOR.crimson, flat: COLOR.ink3 };
export const TOOLTIP_W = 248;

const S = {
  card: {
    width: `${TOOLTIP_W}px`,
    background: "#fff",
    border: `1px solid ${COLOR.line}`,
    borderRadius: "10px",
    boxShadow: "0 8px 24px rgba(11,11,20,0.14), 0 1px 3px rgba(11,11,20,0.08)",
    fontFamily: FONT_SANS,
    color: COLOR.ink,
    overflow: "hidden",
    pointerEvents: "none",
  },
  accent: (colors) => ({
    height: "4px",
    background: colors.length > 1 ? `linear-gradient(90deg, ${colors[0]}, ${colors[1]})` : colors[0],
  }),
  body: { padding: "10px 12px 10px" },
  title: { fontSize: "13px", fontWeight: 700, lineHeight: 1.3 },
  subtitle: { fontSize: "11px", color: COLOR.ink4, fontWeight: 600, marginTop: "1px" },
  metricRow: { display: "flex", alignItems: "baseline", gap: "6px", margin: "8px 0 6px" },
  metricValue: { fontSize: "20px", fontWeight: 700, letterSpacing: "-0.4px", lineHeight: 1 },
  metricUnit: { fontSize: "12px", fontWeight: 600, color: COLOR.ink3 },
  metricHint: { marginLeft: "auto", fontSize: "11px", color: COLOR.ink4, fontWeight: 600 },
  rows: { borderTop: `1px solid ${COLOR.line}`, paddingTop: "6px", display: "grid", rowGap: "3px" },
  row: { display: "flex", justifyContent: "space-between", gap: "12px", fontSize: "12px" },
  rowLabel: { color: COLOR.ink3, display: "flex", alignItems: "center", gap: "6px" },
  rowValue: { fontWeight: 700, whiteSpace: "nowrap" },
  footer: {
    padding: "6px 12px",
    background: COLOR.paper2,
    fontSize: "11px",
    fontWeight: 600,
    color: COLOR.ink3,
  },
};

export function SankeyTooltip({ model }) {
  if (!model) return null;
  const rows = model.rows || [];
  return (
    <div style={S.card} role="tooltip" data-testid="bucket-sankey-tooltip">
      <div style={S.accent(model.accents || [])} />
      <div style={S.body}>
        <div style={S.title}>{model.title}</div>
        <div style={S.subtitle}>{model.subtitle}</div>

        <div style={S.metricRow}>
          <span style={S.metricValue}>{model.metric?.value}</span>
          <span style={S.metricUnit}>{model.metric?.unit}</span>
          {model.metric?.hint && <span style={S.metricHint}>{model.metric.hint}</span>}
        </div>

        {rows.length > 0 && (
          <div style={S.rows}>
            {rows.map((r) => (
              <div key={r.label} style={S.row}>
                <span style={S.rowLabel}>
                  {r.swatch && (
                    <span style={{ width: 7, height: 7, borderRadius: 2, background: r.swatch, flex: "none" }} />
                  )}
                  {r.label}
                </span>
                <span style={{ ...S.rowValue, color: r.tone ? TONE_COLOR[r.tone] : COLOR.ink }}>{r.value}</span>
              </div>
            ))}
          </div>
        )}
      </div>
      {model.footer && <div style={S.footer}>{model.footer}</div>}
    </div>
  );
}

export default SankeyTooltip;
